import { Alert, Spin } from "antd";

interface LoadingStateProps {
  isPending: boolean;
  isError: boolean;
  errorMessage?: string;
  loadingMessage?: string;
}

export const LoadingState = ({
  isPending,
  isError,
  errorMessage = "Er is iets misgegaan. Probeer het later opnieuw of neem contact op met de klantenservice.",
  loadingMessage = "Bezig met het laden van het formulier...",
}: LoadingStateProps) => {
  if (!isPending && !isError) return null;

  return (
    <div style={{ textAlign: "center", padding: "40px 0" }}>
      {isError ? (
        <Alert
          message="Er is een fout opgetreden"
          description={errorMessage}
          type="error"
          style={{ maxWidth: "800px", margin: "0 auto" }}
        />
      ) : (
        <>
          <h2 className="text-gray-800 text-lg mb-4">{loadingMessage}</h2>
          <Spin size="large" />
        </>
      )}
    </div>
  );
};
